import { lessonAtom } from "@core/grades/atoms";
import { trans } from "@mongez/localization";
import { AlignStartVertical, Sparkles } from "lucide-react";

export function LessonDescription() {
  const description = lessonAtom.get("description");

  if (!description) return null;

  return (
    <section className="overflow-hidden rounded-3xl border border-violet-100 bg-gradient-to-br from-violet-50 via-white to-sky-50 p-5 dark:border-violet-950 dark:from-violet-950/30 dark:via-slate-950 dark:to-sky-950/20">
      <div className="mb-4 flex items-center gap-3">
        <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-violet-600 text-white shadow-lg shadow-violet-200 dark:shadow-none">
          <AlignStartVertical className="h-5 w-5" />
        </span>
        <div>
          <p className="flex items-center gap-1.5 text-xs font-black text-violet-600 dark:text-violet-300">
            <Sparkles className="h-3.5 w-3.5" />
            {trans("grades.lessonOverview")}
          </p>
          <h3 className="mt-0.5 text-lg font-black text-slate-950 dark:text-white">
            {trans("description")}
          </h3>
        </div>
      </div>
      <div className="prose prose-slate max-w-none dark:prose-invert">
        <p className="whitespace-pre-line text-sm leading-7 text-slate-600 dark:text-slate-300">
          {description}
        </p>
      </div>
    </section>
  );
}
